module.exports = __webpack_public_path__ + "static/media/ai-view.004b1b8e.svg";